// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__dlFoQ","colMaxWidth":"Table_colMaxWidth__16OG0"};